import { Navigate } from "react-router-dom";
const PublicRoute = ({ element, isLoggedIn }) => {
  return !isLoggedIn ? element : <Navigate to="/portal/dashboard" />;
};
export default PublicRoute;
